import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../store/use-thunk-dispatch';

export const SPONSOR_BANNER_DELETED = 'SPONSOR_BANNER_DELETED';

export const sponsorBannerDeleted = (id: number) => {
    return {
        type: SPONSOR_BANNER_DELETED,
        id,
    };
};

export const deleteSponsorBanner = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(sponsorBannerDeleted(id));

        const response = await api.contentManagement.SponsorBanner.deleteSponsorBanner(id);

        if (!response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
